import { CURRENT_CLIENT } from '@/constants'

/**
 * Platform focus capability modules, config-driven per tenant via
 * client-config `platform.modules`.
 *
 * Missing / non-array `modules` → full set (new tenants degrade to everything on).
 * Explicit `[]` → no modules (waitlist/enquiries still follow signup mode).
 */
export type PlatformModule =
  | 'engagement'
  | 'rubrics'
  | 'simulation'
  | 'skills'
  | 'feedback'
  | 'users'
  | 'organisations'
  | 'marketplace'
  | 'classifiers'

export const ALL_PLATFORM_MODULES: PlatformModule[] = [
  'engagement',
  'rubrics',
  'simulation',
  'skills',
  'feedback',
  'users',
  'organisations',
  'marketplace',
  'classifiers',
]

export function getPlatformModules(): PlatformModule[] {
  const configured = (CURRENT_CLIENT as { platform?: { modules?: string[] } }).platform?.modules
  if (!Array.isArray(configured)) {
    return ALL_PLATFORM_MODULES
  }
  if (configured.length === 0) {
    return []
  }
  return ALL_PLATFORM_MODULES.filter((m) => configured.includes(m))
}

export function isPlatformModuleEnabled(module: PlatformModule): boolean {
  return getPlatformModules().includes(module)
}

/** Maps /platform/* paths to their gating module (paths not listed are always shown). */
export const PLATFORM_PATH_MODULES: Record<string, PlatformModule> = {
  '/platform/engagement': 'engagement',
  '/platform/evaluation-rubrics': 'rubrics',
  '/platform/simulation': 'simulation',
  '/platform/simulation-cleanup': 'simulation',
  '/platform/skills-catalog': 'skills',
  '/platform/feedback': 'feedback',
  '/platform/users': 'users',
  '/platform/organisations': 'organisations',
  '/platform/marketplace-ingest': 'marketplace',
  '/platform/classifiers': 'classifiers',
}
